/**
 * Diagonal corner ribbon flagging the current view as mock data.
 * Styling lives in src/styles/global.css under .mock-ribbon.
 */
export function MockRibbon() {
  return (
    <div className="mock-ribbon" role="note" aria-label="נתוני בדיקה">
      MOCK — לא מחובר לנתונים
    </div>
  );
}
